import React from 'react';

import TipoIncentivo from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Unilever/TipoIncentivo/List.js';

export default function () {
  return <TipoIncentivo />;
}
